var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { subscribeToChannel, unsubscribeFromChannel, publishToChannel } from './messagebus';
/**
 * Publish a message to a channel
 *
 * @example
 * ```
 * publishMessage(props.uxpContext, "visitor-arrival", JSON.stringify({ visitorId: 123 }));
 * ```
 *
 * @export
 */
const publishMessage = (context, channel, message) => __awaiter(void 0, void 0, void 0, function* () {
    return yield publishToChannel(context, channel, message);
});
/**
 * This hook is used to subscribe to a channel on the message bus.
 * The hook takes care of initialization and unsubscribing after the component unmounts
 *
 * @export
 * @param context The Lucy environment context
 * @param channel The channel you want to subscribe to
 * @param callback The function to call when a message comes on the specified channel
 *
 * @example
 * ```
 *
 *  useMessageBus(props.uxpContext, "visitor-arrival", (payload, channel) => {
 *      getVisitorArrivals();
 *      Toast.info("Your visitor is here")
 *  });
 * ```
 *
 */
const useMessageBus = (context, channel, callback) => {
    const callbackRef = React.useRef(callback);
    callbackRef.current = callback;
    React.useEffect(() => {
        let subscriptionId = null;
        subscribeToChannel(context, channel, (payload, ch) => callbackRef.current(payload, ch)).then((id) => {
            subscriptionId = id;
        });
        return () => {
            if (subscriptionId) {
                unsubscribeFromChannel(subscriptionId);
            }
        };
    }, []);
};
export { useMessageBus, publishMessage };
